import { Fragment } from "react";

const EMAIL = "emailsupport@masar.ltd";
const SITE = "masar.ltd";

// Replaces {{email}} and {{site}} tokens with real links.
function rich(text) {
  const parts = String(text).split(/(\{\{email\}\}|\{\{site\}\})/g);
  return parts.map((p, i) => {
    if (p === "{{email}}") {
      return (
        <a key={i} href={`mailto:${EMAIL}`}>
          {EMAIL}
        </a>
      );
    }
    if (p === "{{site}}") {
      return (
        <a key={i} href={`https://${SITE}`}>
          {SITE}
        </a>
      );
    }
    return <Fragment key={i}>{p}</Fragment>;
  });
}

// Renders structured legal blocks: { t: "h2"|"h3"|"p"|"ul", x | items }
export default function LegalBody({ blocks }) {
  return (
    <>
      {blocks.map((b, i) => {
        if (b.t === "h2") return <h2 key={i}>{rich(b.x)}</h2>;
        if (b.t === "h3") return <h3 key={i}>{rich(b.x)}</h3>;
        if (b.t === "ul") {
          return (
            <ul key={i}>
              {b.items.map((li, j) => (
                <li key={j}>{rich(li)}</li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{rich(b.x)}</p>;
      })}
    </>
  );
}
